const DENSITY = {
  comfortable: { pad: 96, gap: 28, hero: 110, body: 17, scale: 1.0 },
  dense:       { pad: 72, gap: 20, hero:  90, body: 15, scale: 0.92 },
  archival:    { pad: 56, gap: 14, hero:  74, body: 14, scale: 0.86 },
};

export default DENSITY;
